// extracted by mini-css-extract-plugin
module.exports = {"slider":"SpecialistCertificateList_slider__B_qg2","slider_locked":"SpecialistCertificateList_slider_locked__LREe0"};